import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SequenceTemplate } from "./types";

interface SequenceCardProps {
  sequence: SequenceTemplate;
  onEdit: () => void;
  onDelete: () => void;
}

export const SequenceCard = ({ sequence, onEdit, onDelete }: SequenceCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{sequence.name || 'Unnamed Sequence'}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">
          {sequence.description || 'No description'}
        </p>
        <p className="text-sm text-muted-foreground mt-2">
          Created: {sequence.created_at ? new Date(sequence.created_at).toLocaleDateString() : 'Unknown date'}
        </p>
      </CardContent>
      <CardFooter className="flex justify-end gap-2">
        <Button 
          variant="outline" 
          onClick={onEdit}
        >
          Edit
        </Button>
        <Button 
          variant="destructive"
          onClick={onDelete}
        >
          Delete
        </Button>
      </CardFooter>
    </Card>
  );
};